import httpClient from "../http/http-client";
import { IDataTypeRelation } from './data-types.model';

export default class DataTypeService {
  http;

  constructor() {
    this.http = httpClient
  }

  async getAll(): Promise<IDataTypeRelation[]> {
    return this.http.get(`data-type`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }
}